import * as THREE from "three";
import Experience from "../Experience.js";
import Room from "./Room.js";
import Environment from "./Environment.js";

export default class World {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.debug = this.experience.debug;

        this.setLighting();

        this.resources = this.experience.resources;
        // Wait for resources
        this.resources.on("ready", () => {
            // Setup
            this.environment = new Environment();
            this.room = new Room();
        });

        this.setDebug();
    }

    setLighting() {
        this.ambientLight = new THREE.AmbientLight("#ffffff", 3);
        this.scene.add(this.ambientLight);

        // this.sunLight = new THREE.DirectionalLight("#ffffff", 4);
        // this.sunLight.castShadow = true;
        // this.sunLight.shadow.camera.far = 20;
        // this.sunLight.shadow.mapSize.set(2048, 2048);
        // this.sunLight.shadow.radius = 4;
        // // this.sunLight.shadow.bias = -0.001;
        // this.sunLight.position.set(0.5, 1, -3);
        // this.scene.add(this.sunLight);
    }

    update() {}

    setDebug() {
        if (this.debug.active) {
            const debugFolder = this.debug.ui.addFolder("world");
            debugFolder
                .add(this.ambientLight, "intensity")
                .min(0)
                .max(10)
                .step(0.001)
                .name("ambientLightIntensity");
            // debugFolder
            //     .add(this.sunLight, "intensity")
            //     .min(0)
            //     .max(10)
            //     .step(0.001)
            //     .name("sunLightIntensity");
            // debugFolder
            //     .add(this.sunLight.position, "x")
            //     .min(-5)
            //     .max(5)
            //     .step(0.001)
            //     .name("sunLightX");
            // debugFolder
            //     .add(this.sunLight.position, "y")
            //     .min(-5)
            //     .max(5)
            //     .step(0.001)
            //     .name("sunLightY");
            // debugFolder
            //     .add(this.sunLight.position, "z")
            //     .min(-5)
            //     .max(5)
            //     .step(0.001)
            //     .name("sunLightZ");
        }
    }
}
